import Toggler from './components/toggler';
window.addEventListener('DOMContentLoaded', () => {

  new Toggler('[data-toggle]', {
    'resize': true
  });
  
});
